(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-video-new-b"] && !Shopify.designMode) return;
  try {
    
/* Campaign video (campaign-video-new-b).

   A custom element rather than a DOMContentLoaded sweep: the theme editor
   re-renders a section by replacing its markup, and connectedCallback runs
   again on the new copy by itself, with no section:load listener to maintain.

   The player markup is cloned out of an inert <template> on the first press,
   which is what keeps the film off the wire until then. With autoplay on, the
   same clone happens when the frame first nears the viewport instead. */
if (!customElements.get('dpd-campaign-video')) {
  customElements.define(
    'dpd-campaign-video',
    class DpdCampaignVideo extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-dpdcv-frame]');
        this.button = this.querySelector('[data-dpdcv-play]');
        this.playerTemplate = this.querySelector('[data-dpdcv-player]');
        this.tracksTemplate = this.querySelector('[data-dpdcv-tracks]');
        if (!this.frame || !this.button || !this.playerTemplate) return;

        this.onPlay = this.onPlay.bind(this);
        this.button.addEventListener('click', this.onPlay);

        /* Autoplay is skipped for reduced motion: the poster and play button
           are the whole experience there, as they are with autoplay off. */
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduceMotion && 'IntersectionObserver' in window) {
          this.autoPaused = false;
          this.observer = new IntersectionObserver(this.onIntersect.bind(this), { rootMargin: '200px 0px' });
          this.observer.observe(this.frame);
        }
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onPlay);
        this.stopObserving();
      }

      stopObserving() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      /* First approach mounts the film. After that, leaving the viewport pauses
         it and coming back resumes it, but only if we were the ones who paused
         it: a film the visitor paused stays paused. */
      onIntersect(entries) {
        var entry = entries[entries.length - 1];
        var video = this.frame.querySelector('video');
        if (entry.isIntersecting) {
          if (!video) {
            this.mount(true);
          } else if (this.autoPaused) {
            this.autoPaused = false;
            var resumed = video.play();
            if (resumed && resumed.catch) resumed.catch(function () {});
          }
        } else if (video && !video.paused) {
          this.autoPaused = true;
          video.pause();
        }
      }

      /* The browser refused to start a muted film (iOS Low Power Mode does
         this). Put the poster and play button back so a press still works. */
      /* NotAllowedError is a real refusal: go back to the poster. Anything else
         (typically Chrome pausing a silent film in a background tab to save
         power) is temporary, so the film stays mounted, the poster stays up,
         and playback is retried once the tab is visible again. */
      onAutoplayRefused(err, video) {
        if (!err || err.name === 'NotAllowedError' || document.visibilityState === 'visible') {
          this.revertToPoster();
          return;
        }
        var self = this;
        var retry = function () {
          if (document.visibilityState !== 'visible') return;
          document.removeEventListener('visibilitychange', retry);
          if (!video.isConnected) return;
          var again = video.play();
          if (again && again.catch) again.catch(function () { self.revertToPoster(); });
        };
        document.addEventListener('visibilitychange', retry);
      }

      revertToPoster() {
        this.stopObserving();
        this.frame.classList.remove('is-playing', 'is-auto-pending');
        var video = this.frame.querySelector('video');
        if (video) video.remove();
      }

      fail() {
        this.stopObserving();
        this.frame.classList.remove('is-playing', 'is-auto-pending');
        this.frame.classList.add('is-error');
        var video = this.frame.querySelector('video');
        if (video) video.remove();
      }

      onPlay() {
        /* A press while an autoplaying film is still loading: play that one
           rather than mounting a second copy. */
        var existing = this.frame.querySelector('video');
        if (existing) {
          this.stopObserving();
          this.frame.classList.remove('is-auto-pending');
          this.frame.classList.add('is-playing');
          var p = existing.play();
          if (p && p.catch) p.catch(function () {});
          return;
        }
        this.mount(false);
      }

      mount(auto) {
        var fragment = this.playerTemplate.content.cloneNode(true);
        var video = fragment.querySelector('video');
        if (!video) {
          this.fail();
          return;
        }

        /* Phones only start a film on their own when it is muted and inline.
           The attribute and the property are both set: some browsers read the
           attribute when deciding, others the property. */
        if (auto) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          if (this.dataset.loop === 'true') video.loop = true;
        }

        if (this.tracksTemplate) {
          video.appendChild(this.tracksTemplate.content.cloneNode(true));
        }

        /* A <source> that fails fires its error on the source element and does
           not bubble, so the listener has to run in the capture phase to catch
           both it and an error on the video itself. */
        var self = this;
        video.addEventListener('error', function () { self.fail(); }, true);

        this.frame.appendChild(fragment);

        var added = this.frame.querySelector('video');
        if (!added) {
          this.fail();
          return;
        }

        /* Autoplay keeps the poster up until the first frame is drawn. A press
           shows the player straight away, as it always has. */
        var frame = this.frame;
        if (auto) {
          frame.classList.add('is-auto-pending');
          added.addEventListener('playing', function () {
            frame.classList.remove('is-auto-pending');
            frame.classList.add('is-playing');
          }, { once: true });
        } else {
          frame.classList.add('is-playing');
        }

        /* `default` on a track marks it as preferred but does not reliably turn
           captions on, so the matching track is switched on explicitly once the
           text tracks exist. */
        var showCaptions = function () {
          var tracks = added.textTracks;
          if (!tracks || !tracks.length) return;
          var wanted = document.documentElement.lang || 'en';
          var chosen = null;
          for (var i = 0; i < tracks.length; i++) {
            if (tracks[i].kind !== 'captions' && tracks[i].kind !== 'subtitles') continue;
            if (!chosen) chosen = tracks[i];
            if (tracks[i].language && wanted.indexOf(tracks[i].language) === 0) chosen = tracks[i];
          }
          if (chosen) chosen.mode = 'showing';
        };
        showCaptions();
        added.addEventListener('loadedmetadata', showCaptions, { once: true });

        /* Explicitly run the resource selection algorithm. A <video> adopted
           out of a template does not reliably start on its own. */
        added.load();

        var played = added.play();
        if (auto) {
          /* Never move focus for a film nobody asked to play: it would scroll
             the page to it. */
          if (played && played.catch) played.catch(function (err) { self.onAutoplayRefused(err, added); });
          return;
        }
        if (played && played.catch) played.catch(function () { /* the user can press the native control */ });
        added.focus();
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let CurrentTimeDate, ca_activate_time, ca_deactivate_time;
    CurrentTimeDate = new Date().getTime();
    if (document.querySelectorAll('[ca_activate_time]').length > 0) {
      ca_activate_time = new Date(
        document.querySelector('[ca_activate_time]').getAttribute('ca_activate_time')
      ).getTime();
      ca_deactivate_time = new Date(
        document.querySelector('[ca_deactivate_time]').getAttribute('ca_deactivate_time')
      ).getTime();
      if (CurrentTimeDate > ca_activate_time && CurrentTimeDate < ca_deactivate_time) {
        document.querySelector('.index-promo-section.cv-Canada').classList.remove('hidden');
      } else {
        document.querySelector('.index-promo-section.cv-Canada').classList.add('hidden');
      }
    }
    if (document.querySelectorAll('[usa_activate_time]').length > 0) {
      usa_activate_time = new Date(
        document.querySelector('[usa_activate_time]').getAttribute('usa_activate_time')
      ).getTime();
      usa_deactivate_time = new Date(
        document.querySelector('[usa_deactivate_time]').getAttribute('usa_deactivate_time')
      ).getTime();
      if (CurrentTimeDate > usa_activate_time && CurrentTimeDate < usa_deactivate_time) {
        document.querySelector('.index-promo-section.cv-USA').classList.remove('hidden');
      } else {
        document.querySelector('.index-promo-section.cv-USA').classList.add('hidden');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
